import { WelcomeWizardStepKind } from "../Authentication/authentication";
import { Theme } from "../Branding/UserTheme/userTheme";
import { environmentHttpClient } from "../httpClient";
import { ActivityEmailKind } from "../WorkspaceManagement/workspaceManagement";

export function saveFirstLoginDone(
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.put<void>(
		"WelcomeScreen/OnFirstLoginDone",
		undefined,
		{ signal }
	);
}

export type SaveWelcomeScreenFormStepModel = {
	formStep: WelcomeWizardStepKind;
};

export function saveWelcomeScreenFormStep(
	model: SaveWelcomeScreenFormStepModel,
	signal?: AbortSignal
): Promise<void> {
	return environmentHttpClient.put<void>(
		"WelcomeScreen/SaveWelcomeScreenFormStep",
		model,
		{ signal }
	);
}

export type UserPreferencesViewModel = {
	canChangeEmailPreferences: boolean;
	activityEmailKind: ActivityEmailKind | null;
};

export type SaveUserPreferencesModel = {
	theme: Theme;
	activityEmailKind: ActivityEmailKind | null;
};

export function getUserPreferences(signal?: AbortSignal): Promise<UserPreferencesViewModel> {
	return environmentHttpClient.get<UserPreferencesViewModel>(
		"WelcomeScreen/UserPreferences",
		undefined,
		{ signal }
	);
}

export function saveUserPreferences(model: SaveUserPreferencesModel, signal?: AbortSignal): Promise<void> {
	return environmentHttpClient.put<void>(
		"WelcomeScreen/UserPreferences",
		model,
		{ signal }
	);
}